import React, { useState } from "react";
import "./AboutQAContent.css";
import Breadcrumb from "./Breadcrumb";
import Modal from "@mui/material/Modal";
import Dropdown from "react-bootstrap/Dropdown";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
import Carousel from "nuka-carousel";
import { LinearProgress, makeStyles, createStyles } from "@material-ui/core";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import QALKMContent from "./QALKMContent";
import QACoverageContent from "./QACoverageContent";
import mailData from "../Data/mailData.js";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "44%",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      top: "67%",
      left: "23%",
      right: "6%",
    },
    linearProgress: {
      width: theme.spacing(117),
    },
  })
);

const useStylesNew = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "44%",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      top: "51%",
      left: "23%",
      right: "7%",
    },
    linearProgress: {
      width: theme.spacing(117),
    },
  })
);

const carouselImage = [
  "/images/AboutQA/main-stream1.png",
  "/images/AboutQA/main-stream2.png",
  "/images/AboutQA/tech-21.png",
  "/images/AboutQA/main-stream4.png",
  "/images/AboutQA/main-stream5.png",
  "/images/AboutQA/main-stream6.png",
];

const carouselImage1 = [
  "/images/AboutQA/tech-1.png",
  "/images/AboutQA/tech-2.png",
  "/images/AboutQA/tech-3.png",
  "/images/AboutQA/tech-4.png",
  "/images/AboutQA/tech-5.png",
  "/images/AboutQA/tech-6.png",
  "/images/AboutQA/tech-7.png",
  "/images/AboutQA/tech-8.png",
  "/images/AboutQA/tech-9.png",
  "/images/AboutQA/tech-10.png",
  "/images/AboutQA/tech-11.png",
  "/images/AboutQA/tech-12.png",
  "/images/AboutQA/tech-13.png",
  "/images/AboutQA/tech-14.png",
  "/images/AboutQA/tech-15.png",
  "/images/AboutQA/tech-16.png",
  "/images/AboutQA/tech-17-new.png",
  "/images/AboutQA/tech-18.png",
  "/images/AboutQA/tech-19.png",
  "/images/AboutQA/tech-20.png",
  "/images/AboutQA/tech-21.png",
  "/images/AboutQA/tech-22.png",
  "/images/AboutQA/tech-23-new.png",
  "/images/AboutQA/tech-24.png",
  "/images/AboutQA/tech-25.png",
  "/images/AboutQA/tech-26.png",
  "/images/AboutQA/tech-27.png",
  "/images/AboutQA/tech-28.png",
  "/images/AboutQA/tech-29.png",
  "/images/AboutQA/tech-30.png",
  "/images/AboutQA/tech-31.png",
  "/images/AboutQA/tech-32.png",
  "/images/AboutQA/tech-33.png",
  "/images/AboutQA/tech-34.png",
  "/images/AboutQA/tech-35.png",
  "/images/AboutQA/tech-36-new.png",
  "/images/AboutQA/tech-37.png",
];
const AboutQAContent = () => {
  const classes = useStyles();
  const classesNew = useStylesNew();

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const isVerySmallScreen = useMediaQuery(theme.breakpoints.up("xs"));
  const isVeryLargeScreen = useMediaQuery(theme.breakpoints.up("xl"));

  const [currentSlides, setCurrentSlides] = useState(0);
  const [currentSlidesTech, setCurrentSlidesTech] = useState(0);
  const [qaActivitiesOpen, setQaActivitiesOpen] = useState(false);
  const SlideNumbers = (currentSlide) => {
    setCurrentSlides(currentSlide);
  };
  const techSlideNumbers = (currentSlide) => {
    setCurrentSlidesTech(currentSlide);
  };

  return (
    <>
      {/* <Breadcrumb/> */}
      <div className="main-banner">
        <img
          src={process.env.PUBLIC_URL + "/images/AboutQA/LKM_QA_Banner.png"}
          alt="Banner"
          className="banner-img"
        />
        <div className="banner-content">
          <h1>Quality Assurance @L&TT </h1>
          {/* <p><i>Lorem ipsum is simply dummy text of the printing</i></p> */}
        </div>
      </div>
      <div className="aboutQA_container">
        {/* <div className="aboutQA_section">
            <div className='aboutQA_img_container'>
                <div><img src={process.env.PUBLIC_URL +"/images/AboutQA/Video_image.png"} alt="home" className="responsiveImg" /></div>
            <div className='aboutQA_img_playbutton'><img src={process.env.PUBLIC_URL +"/images/AboutQA/Play_button.png"} alt="home" className="playButtonImg" /></div>
            
            </div>  
                <div className="AboutQA_Text">
                    <h2 className="sectionHeading">Quality Assurance</h2>
                    <p className="AboutQA_P"> 
                    Quality assurance focuses on providing confidence that quality requirements will be fulfilled and includes all the planned and systematic activities implemented in a quality management system so that quality requirements for a product or service will be fulfilled.
                    </p>
                    <p className="AboutQA_P"> 
                    The ISO (International Organization for Standardization) is a driving force behind QA practices and mapping the processes used to implement QA. QA is often paired with the ISO 9000 international standard. Many companies use ISO 9000 to ensure that their quality assurance system is in place and effective.
                    </p>
                    <p className="AboutQA_P"> 
                    The concept of QA as a formalized practice started in the manufacturing industry, and it has since spread to most industries, including software development.
                    </p>
                </div>
            </div> */}
        <div className="aboutQA_mid_section">
          {/* <h2>What is QA?</h2>
          <p className='aboutQA_mid_section_para'>Quality Assurance (QA) is an integrated system of quality management activities involving planning, implementation, assessment, reporting, and quality improvement to ensure that a process, product, or service is of the type and quality needed and expected by the customer.</p>
          <p className='aboutQA_mid_section_para'>QA consists of that “part of quality management focused on providing confidence that quality requirements will be fulfilled” (ISO 9000). QA is process oriented.</p>
          <p className='aboutQA_mid_section_para'>Auditing is part of the quality assurance function. It is important to ensure quality because it is used to compare actual conditions with requirements and to report those results to management.</p>
          <p className='aboutQA_mid_section_para'>Examples of quality assurance activities include process checklists, process standards, process documentation and project audit.</p> */}
          <div class="lp-name-btn-container">
            <span
              class="lp-menu-btn"
              onMouseOver={() => {
                setQaActivitiesOpen(true);
              }}
            >
              Key Activities
            </span>
            <p>
              Quality Assurance at L&TT encompasses the following activities.
            </p>
          </div>
          {/* <div className='aboutQA_infographic'>
            <img src={process.env.PUBLIC_URL + "/images/AboutQA/Qa_Activities_info.png"} alt="aboutQA" className="responsiveImg" />
          </div> */}
          <Modal
            open={qaActivitiesOpen}
          // onMouseOut={() => setQaActivitiesOpen(false)}
          >
            <div className="model">
              <div className="closeIcon">
                <img
                  src={process.env.PUBLIC_URL + "/images/AboutQA/ql_close.png"}
                  alt="aboutQAClose"
                  className="references-close-btn"
                  onClick={() => {
                    setQaActivitiesOpen(false);
                  }}
                />
              </div>
              <div className="aboutQA_infographic">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/AboutQA/Qa_Activities_info.png"
                  }
                  alt="aboutQA"
                  className="responsiveImg"
                />
              </div>
            </div>
          </Modal>
        </div>

        {/* <div className="learningpath_section">
            <div className="learningpath_para">
                <h2>LKM QA Charter</h2>
            <p>Applicable to LKM as a function, including different work streams, with focus on defining the processes, implementation, formal reviews/audits, measurement and reporting on continual basis.</p></div>
        <div className="learningpath_dropdown">
        <img src={process.env.PUBLIC_URL +"/images/AboutQA/down-arrow.png"} alt="aboutQA" className="downarrowImg"/>
        <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic">
      <img src={process.env.PUBLIC_URL +"/images/AboutQA/down-arrow.png"} alt="aboutQA" className="downarrowImg"/>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
        <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
        </div>
        </div> */}
      </div>

      <div className="icons-container">
        <div className="icons-wrap">
          <div className="icons-row row1">
            <div className="icons-box">
              <div className="img-link">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"}
                  alt="Mailicon"
                  className="group-img mailIcon"
                  id="icon-chat"
                />
                <a
                  className="contact-us"
                  target="_blank"
                  href={`mailto:${mailData.dellearningframework}`}
                >
                  <span className="menu-text">Write to us</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <QALKMContent />
      {/* <QACoverageContent /> */}
      <div className="Scope_heading">
        <h2>QA Coverage</h2>
        <div className="scope_QA_wrapper">
          <div className="scope_QA_container">
            <h2>Streams:</h2>
          </div>
          <div className="scope_QA_cards">
            <Carousel
              id="scope_QA_carousel"
              afterSlide={SlideNumbers}
              beforeSlide={SlideNumbers}
              slidesToShow={
                isVeryLargeScreen
                  ? 4
                  : isLargeScreen
                    ? 4
                    : isMediumScreen
                      ? 2
                      : isSmallScreen
                        ? 2
                        : isVerySmallScreen
                          ? 1
                          : 4
              }
              renderCenterCenterControls={null}
              wrapAround={true}
              renderCenterLeftControls={({ previousSlide }) => (
                <div className="scope_qa_arw_sec-left" onClick={previousSlide}>
                  <img
                    src="/images/AboutQA/left-arrow.png"
                    alt="scope_QA"
                    className="scope_arw-right"
                  />
                </div>
              )}
              renderCenterRightControls={({ nextSlide }) => (
                <div className="scope_qa_arw_sec-right" onClick={nextSlide}>
                  <img
                    src="/images/AboutQA/right-arrow.png"
                    alt="scope_QA"
                    className="scope_arw-right"
                  />
                </div>
              )}
            >
              {carouselImage.map((item) => {
                return (
                  <>
                    <div className="Scope_QA_Img">
                      <img src={item} className="scope_QA" />
                    </div>
                  </>
                );
              })}
            </Carousel>
            <div className="scope_qa_count">
              {currentSlides + 1}/{carouselImage.length}
            </div>
            <div className={classes.root}>
              <LinearProgress
                variant="determinate"
                className={classes.linearProgress}
                value={((currentSlides + 1) * 100) / carouselImage.length}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="Scope_heading1">
        <div className="scope_QA_wrapper row2">
          <div className="scope_QA_container">
            <h2>Sub Streams:</h2>
          </div>
          <div className="scope_QA_cards1">
            <Carousel
              id="scope_QA_carousel"
              afterSlide={techSlideNumbers}
              beforeSlide={techSlideNumbers}
              slidesToShow={
                isVeryLargeScreen
                  ? 4
                  : isLargeScreen
                    ? 4
                    : isMediumScreen
                      ? 2
                      : isSmallScreen
                        ? 2
                        : isVerySmallScreen
                          ? 1
                          : 4
              }
              renderCenterCenterControls={null}
              wrapAround={true}
              renderCenterLeftControls={({ previousSlide }) => (
                <div
                  className="scope_qa_arw_sec-left row2"
                  onClick={previousSlide}
                >
                  <img
                    src="/images/AboutQA/left-arrow.png"
                    alt="scope_QA"
                    className="scope_arw-right"
                  />
                </div>
              )}
              renderCenterRightControls={({ nextSlide }) => (
                <div
                  className="scope_qa_arw_sec-right row2"
                  onClick={nextSlide}
                >
                  <img
                    src="/images/AboutQA/right-arrow.png"
                    alt="scope_QA"
                    className="scope_arw-right"
                  />
                </div>
              )}
            >
              {carouselImage1.map((item) => {
                return (
                  <>
                    <div className="Scope_QA_Img">
                      <img src={item} className="scope_QA" />
                    </div>
                  </>
                );
              })}
            </Carousel>
            <div className="scope_qa_count1">
              {currentSlidesTech + 1}/{carouselImage1.length}
            </div>
            <div className={classesNew.root}>
              <LinearProgress
                variant="determinate"
                className={classes.linearProgress}
                value={((currentSlidesTech + 1) * 100) / carouselImage1.length}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="link_container_below">
        <div className="link_cont_wrap">
          <div>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Home/Acc_GT_Dimensional_RGB.png"
              }
              alt="AccentureIcon"
              className="link_accenture_logo"
            />
          </div>
          <div className="link_text_cont">
            <span>
              For any queries or support, you may reach out to
              <a
                className="link_anchor"
                href={`mailto:${mailData.qualityassurance}`}
                target="_blank"
              >
                {" "}
                {mailData.qualityassurance}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutQAContent;
